<div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
  <div class="container-dialog-complements">
    <p class="title"><span>¿Deseas agregar complementos?</span></p>
    <div class="complements">
      <div class="complements-to-add">
        <div class="checks-container">
          <app-check-payment
            (itemChange)="itemHasChanged()"
            [showQuantity]="true"
            [roundedButtons]="true"
            [checkTop]="true"
            [checkTopText]="''"
            [canHideCounter]="false"
            [noCheck]="true"
            *ngFor="let x of data.complements.length | fill; let i = index"
            [(item)]="data.complements[i]">
          </app-check-payment>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="fad-movil" *ngIf="isMobile === true  || isTablet === true">
  <div class="box-container">
    <div class="content-res">
      <br>
      <p class="title-header">¿Deseas agregar Complementos?</p>
      <div class="form-container">
        <app-check-payment
          (itemChange)="itemHasChanged()"
          [showQuantity]="true"
          [roundedButtons]="true"
          [checkTop]="true"
          [checkTopText]="''"
          [canHideCounter]="false"
          [noCheck]="true"
          *ngFor="let x of data.complements.length | fill; let i = index"
          [(item)]="data.complements[i]">
        </app-check-payment>
      </div>
    </div>
  </div>
</div>
